import React from 'react';
import { Link } from 'react-router-dom';
// import StarRatingComponent from 'react-star-rating-component';
import { connect } from 'react-redux';
// import { this.props.history } from 'react-router';
import { bindActionCreators } from 'redux';
import * as SpecialistblogActions from '../../actions/SpecialistblogActions';
import * as constant from '../../constants/constant';
import Pagination from "react-js-pagination";
import Moment from 'react-moment';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import autoBind from 'auto-bind';
import $ from "jquery";
import * as dashboardActions from "../../actions/dashboardActions";

let btnSize = { fontSize: '13' };
class SpecialistBlogList extends React.Component {
	constructor(props, context) {
		super(props, context);
		autoBind(this);
		this.state = {
			isLoader: true,
			blogList: [],
			token: '',
			flag: 1,
			activePage: 1,
			count: 10,
			sortColumnName: '',
			sortOrder: -1,
			logoutButton: false
		}
	
		this.onLogoutclick = this.onLogoutclick.bind(this);
		this.toggle = this.toggle.bind(this);
		this._logout = this._logout.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.handleOutsideClick = this.handleOutsideClick.bind(this);
	


	}
	
	_logout(event) {
		let userId = localStorage.getItem('userId')
		this.props.logoutAction.logout({ 'userId': userId })
		event.preventDefault();
		localStorage.clear();
		this.props.history.push('/');
	}
	toggle() {
		var windowWidth = $(window).width();
		if(windowWidth < 768){
			$("body").toggleClass("sidebar-open");
		}else{
			$("body").toggleClass("sidebar-collapse");
		}	}
	onLogoutclick(data) {
		if (this.state.logoutButton == false) {
			this.setState({
				logoutButton: true
			});
		}
		else {
			this.setState({
				logoutButton: false
			});
		}
	}
	deleteSpecialistblog(item) {
		confirmAlert({
			title: 'Confirm',
			message: 'Do you wish to delete ' + item.blogTitle + ' health tips ?',
			buttons: [
				{
					label: 'Yes',
					onClick: () => {
						let object = {
							page: this.state.activePage,
							count: this.state.count,
							userId: localStorage.getItem('userId')
						}
						let Id = item._id
						this.props.actions.deleteSpecialistBlog(object, Id);
					}
				},
				{
					label: 'No',
					onClick: () => { this.props.history.push('/specialist/my-blog'); }
				}
			]
		})

	}

	goToAddblogPage() {
		this.props.history.push('/specialist/add-blog');
	};
	goToEditblogPage(index) {
		this.props.history.push('/specialist/edit-blog/' + this.state.blogList[index]._id);
	}
	componentWillMount() {
		let object = {
			page: this.state.activePage,
			count: this.state.count,
			userId: localStorage.getItem('userId')
		}
		this.props.actions.getSpecialistBlogList(object);
	}

	handlePageChange(pageNumber) {
		this.setState({ activePage: pageNumber });
		let object = {
			page: pageNumber,
			count: this.state.count,
			userId: localStorage.getItem('userId')
		}
		this.props.actions.getSpecialistBlogList(object);
	}

	// function for set sort icon on table header
	_sortClass(filterName) {
		return "fa fa-fw " + ((filterName == this.state.sortColumnName) ? ("fa-sort-" + this.state.sortOrder) : "fa-sort");
	}

	//function for sorting
	sortChanged(sortColumnName, order, e) {
		e.preventDefault();
		this.state.sortColumnName = sortColumnName;
		this.state.page = 1;
		this.state.sortOrder = order == 1 ? -1 : 1;

		let userToken = localStorage.getItem('token');
		let specialistId = localStorage.getItem('userId');
		const sorting = {}
		sorting[sortColumnName] = order.toString().toLowerCase() == 1 ? -1 : 1
		this.state.sorting = sorting;
		let object = {
			page: this.state.page,
			count: this.state.count,
			userId: localStorage.getItem('userId'),
			sorting: sorting
		}
		this.props.actions.getSpecialistBlogList(object);
	}
	componentWillReceiveProps(nextProps) {
		if (nextProps.success) {
			this.setState({
				blogList: nextProps.blogList,
				totalCount: nextProps.totalCount,
				isLoader: false
			})
		} else {
			this.setState({
				isLoader: false
			})
		}
	}

	handleOutsideClick(e) {
		// ignore clicks on the component itself
		if (this.node && this.node.contains(e.target)) {
			return;
		}

		this.handleClick();
	}
	handleClick() {
		if (!this.state.logoutButton) {
			// attach/remove event handler
			document.addEventListener('click', this.handleOutsideClick, false);
		} else {
			document.removeEventListener('click', this.handleOutsideClick, false);
		}

		this.setState(prevState => ({
			logoutButton: !prevState.logoutButton,
		}));
	}

	render() {
		var blogList = this.state.blogList
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		var defaultImagePath =user.gender=='Male'? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER +constant.COMMON_FOLDER +'doctor_m.png': constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER +constant.COMMON_FOLDER +'doctor_f.png';


		
		if (user.image == constant.DEFAULT_USER_IMAGE) {
			if (user.gender == 'Male') {
				imagePath =  constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER  + constant.COMMON_FOLDER + 'doctor_m.png'
			}
			else{
			  imagePath =  constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER  + constant.COMMON_FOLDER + 'doctor_f.png'
			}
		} else {
			var imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/' + user.image;
		}
		var rows = [];
		this.state.blogList.forEach(function (item, index) {
			rows.push(<tr key={index}>
				<td>{index + 1}</td>
				<td><Link to={'/specialist/blogdetails/' + item._id}   style={{ cursor: 'pointer', marginRight: 10 }}>
					{item.blogTitle}
				</Link></td>
				<td>{item.likes} </td>
				<td> <Moment format="DD-MM-YYYY">{item.createdAt}</Moment>     </td>
				<td>
					{/* <Link to={'/specialist/blogdetails/' + item._id} style={{ cursor: 'pointer', marginRight: 10 }} className="redLink"><img src={require('../../images/img/book.png')} width="20px"  style={{ 'cursor': 'pointer' }} /></Link> */}
					<Link onClick={this.goToEditblogPage.bind(this, index)} style={{ cursor: 'pointer', marginRight: 10 }} className="redLink"><img src={require('../../images/edit.png')} alt="" width="14px" /></Link>
					<Link onClick={this.deleteSpecialistblog.bind(this, item)} style={{ "cursor": "pointer" }} className="redLink"><i className="fa fa-trash"></i></Link></td>

			</tr>)
		}.bind(this));
		var userType = localStorage.getItem('userType');
		return (
			<div>
				<ToastContainer  position="bottom-left" rtl={true}/>
				<header className="main-header">
					<Link to="/specialist/my-appointment" className="logo">
						<span className="logo-mini">{userType==='specialist'?<img src={require('../../images/img/logo_er_ms_specialist.png')} alt=''/>:<img src={require('../../images/img/logo_er_ms.png')} alt="" />}</span>
						<span className="logo-lg">{userType==='specialist'?<img src={require('../../images/img/logo_er.png')} alt="" />:<img src="{require('../../images/img/logo_er_old.png')}"/>}</span> </Link>
					<nav className="navbar navbar-static-top" role="navigation">
						<Link href="#" className="sidebar-toggle" data-toggle="push-menu" role="button" onClick={this.toggle}> <img src={require('../../images/img/menu_list.svg')} alt="" /> <span className="sr-only">Toggle navigation</span> </Link>
						<div className="navbar-custom-menu">
							<ul className="nav navbar-nav">
								<li ref={node => { this.node = node; }} onClick={this.handleClick} className={this.state.logoutButton == true ? "dropdown user user-menu show" : "dropdown user user-menu"}>

									<Link href="#" className="dropdown-toggle" data-toggle="dropdown">
										<img src={imagePath} className="user-image" alt="User Image" onError={(e) => { e.target.src = defaultImagePath }} />
										<span className="hidden-xs name-capitalize">{user.firstName ? user.firstName : ''} {user.lastName ? user.lastName : ''}</span> </Link>
									<ul className={this.state.logoutButton === true ? "dropdown-menu popupdropdown show" : "dropdown-menu popupdropdown"}>

										<li className="user-setting">	<Link to={{ pathname: "/specialist/my-settings", state: 1 }}>

											<img
												src={require('../../images/Slicing/Settings-profile.png')}
												className="user-image"
												alt="User Image"
												onError={e => {
													e.target.src = defaultImagePath;
												}}
											/>
											<span>Settings</span>
										</Link></li>
										<li
											className="user-footer passwordLink"
										// style={{ textAlign: "center" }}
										>

											<Link
											
												className="uploadLink"
												onClick={this._logout}
											>
												<img
													src={require('../../images/Slicing/logout-profile.png')}
													className="user-image"
													alt="User Image"
													onError={e => {
														e.target.src = defaultImagePath;
													}}
												/>
												<span>	Sign out</span>
											</Link>
										</li>
									</ul>
								</li>
							</ul>
						</div>
					</nav>
				</header>
				<div className="content-wrapper">

					<section className="content container-fluid">
						<ToastContainer />
						<div className="row">
							<div className="col-md-12">
								<div className="boxMrgB proCalendar">
									<div className="nav-tabs-custom ipad-my-document">
										<ul className="nav nav-tabs  custom-nav">
											<li ><Link to="#tab_1" data-toggle="tab" className="active show">Blog</Link></li>
											<li>
											<button className="btn btn-square btn-w-120" onClick={this.goToAddblogPage}>
											<span style={{display: "flex", alignItems: 'center', justifyContent:'center'}}>
													<img src={require('../../images/img/add.png')} />
													<span className="btn-text">Add Blog</span>
											</span>	
												
												</button>
											</li>
										</ul>
										<div className="row">
											<div className="col-md-12">
												<div className="tab-content tabother ">
													<div className="row">
														<div className="box-body table-responsive no-padding aTable">
															<div className="table-responsive">
																<table className="table">
																	<tbody>
																		<tr>
																			<th >
																				Sr. No.
                                </th>
																			<th onClick={this.sortChanged.bind(this, 'blogTitle', this.state.sortOrder)}>
																				Blog Name
                                <i className={this._sortClass('appointmentspecialistname')}></i></th>
																			<th >
																				Likes
                                </th>
																			<th onClick={this.sortChanged.bind(this, 'createdAt', this.state.sortOrder)}>Creation date<i className={this._sortClass('appointmentspecialistname')}></i></th>
																			<th >Action</th>
																		</tr>
																		{rows && rows.length > 0 ? rows : <tr><td colSpan={4} className="text-center">No Blogs Here yet !</td></tr>}
																	</tbody>
																</table>
															</div></div>
													</div>
													{(blogList && blogList.length > 10) ?
														<div className="row">
															<div className="col-sm-5"><div className="showingEntries">Showing {(this.state.activePage * this.state.count) - (this.state.count - 1)} to {(this.state.activePage * this.state.count) > this.state.totalCount ? this.state.totalCount : (this.state.activePage * this.state.count)} of {this.state.totalCount} entries</div></div>
															<div className="col-sm-7 text-right" style={{ "cursor": "pointer" }}>
																<Pagination
																	prevPageText='Prev'
																	nextPageText='Next'
																	hideFirstLastPages
																	activePage={this.state.activePage}
																	itemsCountPerPage={10}
																	totalItemsCount={this.state.totalCount}
																	pageRangeDisplayed={10}
																	onChange={this.handlePageChange.bind(this)}
																/>

															</div>

														</div> : ''}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>

					<div className="Copyrightafterlogin">
					<p>Medfix &copy; 2018. All rights reserved</p>

					</div>
				</div>
			</div>
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		blogList: state.SpecialistBlog.blogList ? state.SpecialistBlog.blogList.data : [],
		totalCount: state.SpecialistBlog.blogList ? state.SpecialistBlog.blogList.totalCount : 0,
		success: state.SpecialistBlog.blogList ? state.SpecialistBlog.blogList.success : false
	};
}
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(SpecialistblogActions, dispatch),
		logoutAction: bindActionCreators(dashboardActions, dispatch)

	};
}
export default connect(mapStateToProps, mapDispatchToProps)(SpecialistBlogList);